import * as React from 'react';
import {BaseClassName, SummarySpanClassName, PlusMinusClassName} from './../Expander/Expander';

export interface IExpanderGroupProps {
    title?: string;
    groupId: string;
}

/**
 * Controls the server-rendered Detail elements so that only one can be open at a time.
 */
export class ExpanderGroup extends React.Component<IExpanderGroupProps> {
    constructor(props: IExpanderGroupProps) {
        super(props);
    }

    private handleToggle = (indexToHandle: number) => {
        this._summaryItems.forEach((item, index) => {
            const detail = (item as ChildNode).parentElement as HTMLDetailsElement;
            if (index === indexToHandle) {
                detail.open = !detail.open;
            } else {
                if (detail.open) detail.open = false;
            }
        });
    }

    private onSummaryClick = (e:Event) => {
        e.preventDefault();
        const currSummary = e.target as ChildNode;
        const currSummaryIndex = this._summaryItems.findIndex(x => x.isSameNode(currSummary));
        this.handleToggle(currSummaryIndex);
    };
    
    private onSpanClick = (e:Event) => {
        e.stopImmediatePropagation();
        e.preventDefault();
        const currSpan = e.target as ChildNode;
        const currSummaryIndex = this._summaryItems.findIndex(x => x.isSameNode(currSpan.parentElement));
        this.handleToggle(currSummaryIndex);
    };

    
    
    private _summaryItems: ChildNode[] = [];
    componentDidMount() {
        const accordionWrapper = document.querySelector(`#exp-group_${this.props.groupId}`);
        const detailsElems = accordionWrapper.querySelectorAll(`details.${BaseClassName}`);
        detailsElems.forEach(detail => {
            const summaryElem = detail.firstElementChild;
            this._summaryItems.push(summaryElem);
            summaryElem.addEventListener('click', this.onSummaryClick);

            const spanElem = summaryElem.querySelector(`.${PlusMinusClassName}`) as HTMLSpanElement;
            spanElem.addEventListener('click', this.onSpanClick)

            const spanHeadingElem = summaryElem.querySelector(`.${SummarySpanClassName}`) as HTMLSpanElement;
            spanHeadingElem.addEventListener('click', this.onSpanClick)
        });
    }

    public render() {
        return null;
    }
}
